<template>
  <div v-loading="loading">
    <div class="live_text_content" v-if="liveDataList.length > 0">
      <span class="icon_circle_header"></span>
      <span class="icon_circle_footer"></span>
      <dl class="match_progress" v-for="(item, index) of liveDataList" :key="index">
        <dt>{{ item.time }}</dt>
        <dd>
          <h4 class="score">{{ item.home_score }}-{{ item.away_score }}</h4>
          <div class="content">{{ item.data }}</div>
          <span v-if="item.position == 1" class="team_red"></span>
          <span v-if="item.position == 2" class="team_blue"></span>
        </dd>
      </dl>
    </div>
    <div v-if="liveDataList.length == 0 && loading == false">
      <panel-not-data message="当前赛事还没有文字直播..." img-name="queue" />
    </div>
  </div>
</template>

<script>
import PanelNotData from "@/components/match-recommend/not-data";

export default {
  name: "BasketballText",
  data() {
    return {
      loading: true,
      //文字直播数据
      liveDataList: [],
    };
  },
  components: {
    PanelNotData,
  },
  props: {
    matchInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    //增加强行关闭动画的定时器
    setTimeout(() => {
      this.loading = false;
    }, 20000);
  },
  methods: {
    /**
     * 开始处理数据
     */
    runData(ret_data) {
      // console.log("篮球文字直播内页接到的数据：",ret_data);
      let live_data_list = JSON.parse(ret_data.replace(/[\\]+/g, "").slice(1, -1));
      // console.log("篮球文字直播数据：", live_data_list);
      if (live_data_list.length > 0) {
        this.liveDataList = live_data_list[0].text_live.reverse();
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./live_text.scss";

.live_text_content {
  .match_progress {
    dd {
      .content {
        width: calc(100% - 1rem);
      }
    }
  }
}

//[篮球-文字直播]篮球第几节标题样式
.basketball_units {
  clear: both;
  width: calc(100% - 70px);
  overflow: hidden;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 20px 35px;
  margin-bottom: 0;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  -ms-user-select: none;

  li {
    float: left;
    width: 25%;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    background-color: #f6f6f6;
    font-size: 16px;
    color: #999;
    text-align: center;
    cursor: pointer;

    &:hover {
      background-color: rgba(41, 240, 158, 0.1);
      color: #02a1f9;
    }

    &.active {
      background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
      color: #fff;
    }
  }
}
</style>